/* Client-side UX hint only. `assertSafeInput` (lib/validation-server.ts) is authoritative via full
   fakefilter at every API gate; this 50-domain Set ships ~1 KB vs fakefilter's ~84 KB gzip.
   Source: github.com/disposable-email-domains/disposable-email-domains (CC0). */

const DISPOSABLE_EMAIL_DOMAINS = new Set<string>([
  "10minutemail.com",
  "10minutemail.net",
  "33mail.com",
  "anonbox.net",
  "binkmail.com",
  "bobmail.info",
  "burnermail.io",
  "deadaddress.com",
  "discard.email",
  "dispostable.com",
  "easytrashmail.com",
  "emailondeck.com",
  "fake-mail.ml",
  "fakeinbox.com",
  "fakemail.net",
  "fakemailgenerator.com",
  "getairmail.com",
  "guerrillamail.com",
  "guerrillamail.net",
  "guerrillamail.org",
  "guerrillamailblock.com",
  "incognitomail.com",
  "mailinator.com",
  "mailinator.net",
  "maildrop.cc",
  "mintemail.com",
  "mohmal.com",
  "moakt.com",
  "mt2014.com",
  "mt2015.com",
  "mvrht.com",
  "mytempemail.com",
  "sharklasers.com",
  "spam.la",
  "spam4.me",
  "spambox.org",
  "spambox.us",
  "tempinbox.com",
  "tempmail.com",
  "tempmail.io",
  "tempmailo.com",
  "tempr.email",
  "temp-mail.org",
  "throwawaymail.com",
  "tmpmail.org",
  "trashinbox.com",
  "trashmail.com",
  "trbvm.com",
  "wegwerfmail.de",
  "yopmail.com",
])

/** Returns true if email's domain is in the disposable Set. Exact match only — subdomains bypass; server catches. */
const isDisposableEmail = (email: string): boolean => {
  if (!email || typeof email !== "string") return false
  const atIdx = email.lastIndexOf("@")
  if (atIdx < 0 || atIdx === email.length - 1) return false
  const domain = email.slice(atIdx + 1).toLowerCase().trim()
  return DISPOSABLE_EMAIL_DOMAINS.has(domain)
}

export default isDisposableEmail
